import { logSwallowed } from '@/lib/errors';
// ============================================================================
// enumOptions.ts — ЕДИНЫЙ загрузчик значений перечислений (SSoT/SRP).
//
// Перечисление (data_type='enumeration'|'enum') хранит КОД перечисления в
// refTable/refCatalogCode (НЕ таблицу-источник). Здесь — единственное место
// загрузки значений в форму селекта: значение → {value, label: синоним}.
// Используется рендерами форм (автоформы через useObjectFormModel, кастомные
// формы/предпросмотр через FormDesigner) — без дублей логики.
// ============================================================================

import { getSDK } from '@/store/sdkStore';
import type { EnumOption } from '@/components/forms/fieldWidgets';

/** true, если поле — перечисление (data_type = enum/enumeration). */
export function isEnumField(field: unknown): boolean {
  const dt = String((field as { dataType?: string; data_type?: string } | null)?.dataType
    || (field as { data_type?: string } | null)?.data_type || '').toLowerCase();
  return dt === 'enum' || dt === 'enumeration';
}

/** Код перечисления поля (refTable/refCatalogCode/ref_table); '' — не перечисление. */
export function enumRefOf(field: unknown): string {
  if (!isEnumField(field)) return '';
  const f = field as { refTable?: string; refCatalogCode?: string; ref_table?: string } | null;
  return String(f?.refTable || f?.refCatalogCode || f?.ref_table || '');
}

/** ЕДИНЫЙ загрузчик: по набору полей/колонок возвращает карту
 *  «код перечисления → значения» (только для полей-перечислений). */
export async function loadEnumOptions(fields: unknown[]): Promise<Record<string, EnumOption[]>> {
  const refs = Array.from(new Set((fields || []).map(enumRefOf).filter((r) => r !== '')));
  const map: Record<string, EnumOption[]> = {};
  for (const code of refs) {
    // Перечисление удалено/недоступно — поле остаётся без опций (форма НЕ падает).
    const r: any = await getSDK().metadata.getEnum({ code }).catch((e) => { logSwallowed(e, 'lib/enumOptions.ts:35'); return null; });
    if (r?.values) {
      map[code] = r.values.map((v: any) => ({ value: String(v.value), label: v.synonym || v.name || String(v.value) }));
    }
  }
  return map;
}
